import { _js } from '@ifixit/utils/localize';

onDomReady(() => {
   let TRANSLATE_GUIDES = 'guides';
   let TRANSLATE_WIKIS = 'wikis';
   let SORTBY_LOCAL = 'local';
   let SORTBY_GLOBAL = 'global';

   let filterOptions, currentFilter, sortOptions, currentSort;

   initialize();

   function initialize() {
      initializeFilterOptions();
      initializeSortOptions();
   }

   function initializeSortOptions() {
      sortOptions = $$('a.translate-sort');
      let initialSort = $E('.sort-options');

      if (!sortOptions || !initialSort) {
         return;
      }

      currentSort = initialSort ? initialSort.get('data-sortby') : SORTBY_LOCAL;

      // Make sure current sort is a valid option
      if (![SORTBY_LOCAL, SORTBY_GLOBAL].contains(currentSort)) {
         currentSort = SORTBY_LOCAL;
      }

      sortOptions.each(option => {
         option.addEvent('click', updateSortOption);

         let sortName = option.get('data-sort');
         if (sortName == currentSort) {
            option.addClass('sort-option-active');
         }
      });

      $E('.sort-label').addEvent('click', function () {
         this.toggleClass('expanded');
      });
   }

   function initializeFilterOptions() {
      filterOptions = $$('a.translate-filter');
      let initialFilter = $E('.filter-options');

      if (!filterOptions || !initialFilter) {
         return;
      }

      currentFilter = initialFilter ? initialFilter.get('data-filterby') : TRANSLATE_GUIDES;

      // Make sure current filter is a valid option
      if (![TRANSLATE_GUIDES, TRANSLATE_WIKIS].contains(currentFilter)) {
         currentFilter = TRANSLATE_GUIDES;
      }

      filterOptions.each(option => {
         option.addEvent('click', updateFilterOption);

         let filterName = option.get('data-filter');
         if (filterName == currentFilter) {
            option.addClass('filter-option-active');
         }
      });

      $E('.filter-label').addEvent('click', function () {
         this.toggleClass('expanded');
      });
   }

   function updateFilterOption() {
      if (this.hasClass('filter-option-active')) {
         return;
      }

      filterOptions.removeClass('filter-option-active');
      this.addClass('filter-option-active');
      currentFilter = this.get('data-filter');

      updateRows();
   }

   function updateSortOption() {
      if (this.hasClass('sort-option-active')) {
         return;
      }

      sortOptions.removeClass('sort-option-active');
      this.addClass('sort-option-active');
      currentSort = this.get('data-sort');

      updateRows();
   }

   function updateRows() {
      let config = {
         filter: currentFilter,
         sortBy: currentSort,
      };

      updateStateUrl();
      $E('.filter-label').removeClass('expanded');
      $E('.sort-label').removeClass('expanded');

      LoadingIndicator.withPromise(
         new Request.AjaxIO('updateFilters', {
            onSuccess: function (data) {
               if (data.html) {
                  $('translate-guides').set('html', data.html);
               }
            },
         }).send(config),
         {
            pendingMessage: _js('Loading...'),
            failureMessage: _js('Could not update filter'),
            hideSuccessMessage: true,
         }
      );
   }

   function updateStateUrl() {
      let state = {
         filter: currentFilter,
         sortby: currentSort,
      };

      let currentUrl = window.location.href;
      let baseUrl = currentUrl.substring(0, currentUrl.indexOf('?')) || currentUrl;

      let url = new URI(baseUrl);
      let newUrl = url.setData(state).toString();

      history.replaceState(state, '', newUrl);
   }
});
